import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import { StringDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import { NONE } from 'customer-data-filters-ui/filterQueryFormat/timestamps/TimestampTypes';
import { SalesViews } from '../filterQueryFormat/strategy/StrategyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const useInternalValue = (baseFilterFamily, strategy, value, data, fetchMore, getIsUngated, hasScope, isUserInfoFetched) => {
  const getField = useCallback((keyPath, isRefinement = false) => {
    const [assetFamily, id] = keyPath;
    const defaultField = MissingField({
      name: `${id}`,
      timestampType: NONE,
      type: StringDisplayType,
      errorMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.MissingField.fetchFailed"
      })
    });
    if (isRefinement) {
      if ('getRefinementFields' in strategy) {
        const refinementFields = strategy.getRefinementFields(assetFamily) || {};
        return refinementFields[id] || defaultField;
      }
      return defaultField;
    }
    const getFieldProps = {
      baseFilterFamily,
      data,
      fetchMore,
      getIsUngated,
      hasScope
    };
    const fieldFromStrategy = strategy.getField(assetFamily, id, defaultField, getFieldProps);
    return fieldFromStrategy || defaultField;
  }, [strategy, data, baseFilterFamily, fetchMore, getIsUngated, hasScope]);
  const getInternalValue = useCallback(() => {
    if (!value || !isUserInfoFetched) {
      return undefined;
    }
    const serializerOptions = {
      useHoursFiltering: strategy.useHoursFiltering,
      useSalesViewsSerialization: strategy.strategyType === SalesViews
    };
    const filterValue = strategy.serializer.fromFormat(
    // @ts-expect-error fromFormat expects type 'ILSBranchFilter & CRMSearchFilters' because it can't tell which case it's in
    value, baseFilterFamily, getField, getIsUngated, serializerOptions);
    return filterValue;
  }, [strategy, baseFilterFamily, value, getField, getIsUngated, isUserInfoFetched]);
  const internalValue = useMemo(() => getInternalValue(), [getInternalValue]);
  return internalValue;
};